import { Button } from '@mui/material';
import { useGlobalization } from '../../../contexts';
import { StyledFooter } from './Drawer.styles';
import React from 'react';
export const DrawerFooter = ({ onCancelClick, action }) => {
    const { t } = useGlobalization();
    return (React.createElement(StyledFooter, null,
        onCancelClick && (React.createElement(Button, { variant: "contained", color: "secondary", onClick: onCancelClick, "data-cy": "cancelButton" }, t('Cancel'))),
        action && (React.createElement(Button, { "data-cy": "createButton", type: 'button', variant: "contained", color: "primary", onClick: action.onClick, disabled: !action.enabled }, action.title))));
};
export default DrawerFooter;
